import { getUsername } from './getUsername';

export interface IUser {
  getUsername: typeof getUsername;
}

/**
 * @namespace
 */
const User: IUser = {
  getUsername,
};

export default User;
